import Overview from './allOverview.vue';
import Full from './allFull.vue';

export const componentMap = {
    overview: Overview,
    full: Full
};
